export enum AvailableCountryISOEnum {
  AT = 'AT',
  DE = 'DE',
  CH = 'CH',
  OTHER = 'other'
}
